import { useFormContext } from 'react-hook-form';
import { useCampaignContext, useEditorContext, useTemplateContext } from '../../context';

import { CampaignStep } from '../../types';
import { getIsDefaultWhatsAppTemplate } from '../utils';
import { CheckmarkCircle, ValidationCircle } from './CampaignCardIcons';

const CampaignCardState = ({
  campaignStep,
  isInvalid,
  isComplete,
}: {
  campaignStep: CampaignStep;
  isInvalid: boolean;
  isComplete: boolean;
}) => (
  <>
    {isInvalid ? (
      <ValidationCircle campaignStep={campaignStep} />
    ) : (
      <CheckmarkCircle campaignStep={campaignStep} isComplete={isComplete} />
    )}
  </>
);

export const CampaignStepCardState = ({ campaignStep }: { campaignStep: CampaignStep }) => {
  const {
    formState: { isValid, isDirty },
  } = useFormContext();
  const { campaignSteps } = useEditorContext();
  const campaignState = campaignSteps[campaignStep as CampaignStep];
  const isComplete = isDirty && campaignState?.isEditable ? false : campaignState?.isComplete;
  const isInvalid = !isValid && campaignState?.isEditable;
  return (
    <CampaignCardState
      campaignStep={campaignStep}
      isComplete={isComplete as boolean}
      isInvalid={isInvalid as boolean}
    />
  );
};

export const CampaignContentCardState = () => {
  const {
    templateState: { isInvalid, isComplete },
    templateAndContent: { templateType },
  } = useTemplateContext();
  const { campaign } = useCampaignContext();
  const isWhatsAppDefaultTemplate = getIsDefaultWhatsAppTemplate(
    campaign.messageMedium,
    templateType,
  );

  return (
    <CampaignCardState
      campaignStep={CampaignStep.Content}
      isComplete={isComplete}
      isInvalid={!isWhatsAppDefaultTemplate && isInvalid}
    />
  );
};
